import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import App from "./App";
// import dotenv from "dotenv";
// dotenv.config();

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
